import { useTranslation } from 'react-i18next';
import { MilestoneIcon } from '@utils/icons';
import styles from './MilestoneMarker.module.css';

/**
 * Amber diamond shown next to a milestone activity's title (Daily List) or column
 * header (Progress Tracker) — matching the Scheduler's milestone glyph. `size` scales
 * the diamond to its context (title text vs. compact header); `className` lets a caller
 * add context-specific spacing.
 */
export function MilestoneMarker({ size = 12, className }: { size?: number; className?: string }) {
  const { t } = useTranslation();
  const label = t('scheduler.saveReview.milestone');
  return (
    <span className={className ? `${styles.marker} ${className}` : styles.marker} title={label} aria-label={label}>
      <MilestoneIcon size={size} />
    </span>
  );
}
